import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

export class CustomValidators {
  public static passwordLengthValidator(): ValidatorFn {
    return Validators.minLength(8);
  }

  public static patternValidator(
    regex: RegExp,
    error: ValidationErrors
  ): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }

      // test the value of the control against the regexp supplied
      const valid = regex.test(control.value);

      // if true, return no error (no error), else return error passed in the second parameter
      return valid ? null : error;
    };
  }

  public static passwordMatchValidator(control: AbstractControl) {
    const password: string = control.get('password').value; // get password from our password form control
    const confirmPassword: string = control.get('confirmPassword').value; // get password from our confirmPassword form control
    // compare is the password math
    if (password !== confirmPassword) {
      // if they don't match, set an error in our confirmPassword form control
      control.get('confirmPassword').setErrors({ NoPassswordMatch: true });
    }
  }

  public static patternValidatorExcludeRusLetter(regex: RegExp): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }
      const valid = regex.test(control.value);

      return valid ? { pattern: true } : null;
    };
  }

  public static numberFromOneToThousandValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const { value } = control;
      return value >= 1 && value < 1000
        ? null
        : { notInRangeFromZeroToThousand: true };
    };
  }

  public static integerValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      return Number.isInteger(control.value) ? null : { notInteger: true };
    };
  }

  /**
   * Greater than validator
   * @param min Minimum value (exclusive)
   */
  static gt(min: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value && control.value !== 0) {
        return null;
      }
      const value = Number(control.value);
      return value > min ? null : { gt: { min, actual: value } };
    };
  }

  /**
   * Maximum value validator
   * @param max Maximum value (inclusive)
   */
  static max(max: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value && control.value !== 0) {
        return null;
      }
      const value = Number(control.value);
      return value <= max ? null : { max: { max, actual: value } };
    };
  }

  /**
   * Range length validator
   * @param range Array with [min, max] length
   */
  static rangeLength(range: [number, number]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const length = control.value.length;
      const [min, max] = range;
      return length >= min && length <= max
        ? null
        : { rangeLength: { min, max, actual: length } };
    };
  }
}
